import IUser, { UserRoleType } from "@/interfaces/IUser";

export const getColorFromRole = (roles: UserRoleType[]) => {
  if (roles.includes("SDR")) return "warning";
  else if (roles.includes("AE")) return "success";
  else if (roles.includes("SUPERADMIN") || roles.includes("ADMIN"))
    return "primary";
  else if (roles.includes("CSM")) return "info";
  else if (roles.includes("HEADOFSALES")) return "secondary";
  else if (roles.includes("GENERALMANAGER")) return "dark";
  else return "danger";
};

export const getReelRoleName = (roles: UserRoleType[]) => {
  if (roles.includes("SUPERADMIN")) return "Super administrateur";
  if (roles.includes("ADMIN")) return "Administrateur";
  else if (roles.includes("SDR")) return "TéléPro";
  else if (roles.includes("AE")) return "Commercial";
  else if (roles.includes("CSM")) return "CSM";
  else if (roles.includes("HEADOFSALES")) return "Responsable commercial";
  else if (roles.includes("GENERALMANAGER")) return "Directeur général";
  else return "Inconnu";
};

export const getReelRolesName = (roles: UserRoleType[]) => {
  const rolesName = roles.map((role) => getReelRoleName([role]));
  return rolesName.join(", ");
};

export const checkIfUserHasRoles = (
  user: IUser,
  roles: UserRoleType[],
): boolean => {
  if (!user.roles) return false;

  // CSM == ADMIN dans tout le CRM pour l'instant (à revoir plus tard). Les deux
  // rôles passent donc n'importe quelle vérification, sauf la présence qui
  // utilise isStrictAdmin (curseurs / liste des connectés réservés à ADMIN).
  return roles.some((role) =>
    role === "SUPERADMIN"
      ? isSuperAdmin(user)
      : user.roles.includes(role) ||
        user.roles.includes("SUPERADMIN") ||
        user.roles.includes("ADMIN") ||
        user.roles.includes("CSM"),
  );
};

/**
 * ADMIN et SUPERADMIN (exclut CSM). Utilisé par la présence et les réglages Meet.
 */
type RoleHolder = { roles?: readonly string[] } | null | undefined;
export const isStrictAdmin = (user?: RoleHolder): boolean =>
  !!user?.roles?.some((role) => role === "ADMIN" || role === "SUPERADMIN");

export const isSuperAdmin = (user?: RoleHolder): boolean =>
  !!user?.roles?.includes("SUPERADMIN");

export const getReelStateName = (isActive: boolean) =>
  isActive ? "Actif" : "Inactif";

export const getReelStateColor = (isActive: boolean) =>
  isActive ? "success" : "danger";

export const getTvaOrNot = (isActive: boolean) => (isActive ? "Avec" : "Sans");

export const getStateOrNot = (isActive: boolean) =>
  isActive ? "Actif" : "Inactif";
